import type { AddClientInput } from '@/entities/client';

// Pronouns is '' while Other is chosen and nothing is typed, so an empty string is no entry.
export function hasAddClientEntries(values: Partial<AddClientInput>): boolean {
    const { firstName, lastName, preferredFirstName, emailPrimary, phonePrimary, pronouns } =
        values;

    return [firstName, lastName, preferredFirstName, emailPrimary, phonePrimary, pronouns].some(
        (value) => !!value,
    );
}
